"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerTimer = void 0;
const vue_1 = require("vue");
const Timer_1 = require("../../Timer");
exports.PlayerTimer = vue_1.default.component('player-timer', {
    props: {
        timer: {
            type: Object,
        },
    },
    data() {
        return {
            timerText: '',
        };
    },
    mounted() {
        this.updateTimer();
    },
    watch: {
        timerText: {
            handler() {
                setTimeout(() => {
                    this.updateTimer();
                }, 1000);
            },
        },
    },
    methods: {
        updateTimer: function () {
            this.timerText = Timer_1.Timer.toString(this.timer);
        },
        hasHours: function () {
            if (this.timerText.split(':').length > 2) {
                return 1;
            }
            return 0;
        },
        getHours: function () {
            if (this.hasHours()) {
                return this.timerText.split(':')[0];
            }
            return '';
        },
        getMinutes: function () {
            if (this.hasHours()) {
                return this.timerText.split(':')[1];
            }
            return this.timerText.split(':')[0];
        },
        getSeconds: function () {
            if (this.hasHours()) {
                return this.timerText.split(':')[2];
            }
            return this.timerText.split(':')[1];
        },
    },
    template: `
    <div class="player-timer">
      <template v-if="hasHours()">
         <div class="player-timer-hours">{{ getHours() }}</div>
         <div class="timer-delimiter">:</div>
      </template>   
      <div class="player-timer-minutes">{{ getMinutes() }}</div>
      <div class="timer-delimiter">:</div>
      <div class="player-timer-seconds">{{ getSeconds() }}</div>
    </div>
  `,
});
//# sourceMappingURL=PlayerTimer.js.map